import { Check } from "lucide-react";
import { hasLamination } from "@/lib/crmApi";

const slug = (s) => s.replace(/\s+/g, "-").toLowerCase();

export const ProductPicker = ({ meta, lead, onPatch }) => {
  const products = lead.products || [];
  const toggle = (p) => onPatch({ products: products.includes(p) ? products.filter((x) => x !== p) : [...products, p] });
  return (
    <section className="rounded-2xl bg-white border border-slate-200 p-5 space-y-4">
      <div>
        <h2 className="text-sm font-semibold text-slate-900 mb-3">Products</h2>
        <div className="flex flex-wrap gap-2">
          {meta.products.map((p) => {
            const on = products.includes(p);
            return (
              <button key={p} type="button" data-testid={`product-toggle-${slug(p)}`} aria-pressed={on} onClick={() => toggle(p)}
                className={`h-10 px-4 rounded-full text-sm font-medium inline-flex items-center gap-1.5 border transition-colors ${
                  on ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300 hover:border-slate-500"}`}>
                {on && <Check className="h-4 w-4" />}{p}
              </button>
            );
          })}
        </div>
      </div>
      {hasLamination(products) && (
        <div data-testid="die-field">
          <h2 className="text-sm font-semibold text-slate-900 mb-2">Die</h2>
          <select data-testid="die-select" value={lead.die || ""} onChange={(e) => onPatch({ die: e.target.value })}
            className="h-11 w-full sm:w-80 px-3 rounded-xl border border-slate-300 bg-white text-sm">
            <option value="">Not set</option>
            {meta.dies.map((d) => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
      )}
    </section>
  );
};
